import i18n, { type TFunction } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next, I18nextProvider, useTranslation } from 'react-i18next';
import resources from './locales';

const DEFAULT_LOCALE = 'en-US';
const COMMON_NS = 'common';
const NAMESPACES = [COMMON_NS, 'platform', 'recordingConsole'];

const locales = Object.entries(resources).map(([id, locale]) => ({ id, name: locale.common.language ?? id }));
const localeNames = Object.keys(resources);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: NAMESPACES,
    defaultNS: COMMON_NS,
    resources,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: localeNames,
    detection: {
      lookupLocalStorage: 'i18nextLng', // TODO: use key from constants
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    // We'll load only 'en-US', 'en-GB' etc, but not 'en' or 'dev' translations
    load: 'currentOnly',
    interpolation: {
      escapeValue: false,
    },
  });

const getCurrentLocale = () => i18n.language;
const setLocale = (locale: string) => i18n.changeLanguage(locale);

export { i18n, I18nextProvider, useTranslation, locales, getCurrentLocale, setLocale };
export type { TFunction };
